import './ForumCardFooter.css'

export default function ForumCardFooter({report}) {
   return (
      <div className='ForoCardFooter-container'>
         <a className='ForoCardFooter--link' onClick={report} >Denunciar</a>
      </div>
   )
}
